var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMilitaryLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19653)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4002 11.7804L22.8891 14.8822C22.7287 15.2114 22.4149 15.4392 22.0522 15.4898L18.6427 15.9656L21.0651 18.3099C21.3239 18.5604 21.4438 18.9217 21.3859 19.2771L20.8294 22.6953L23.8982 21.1216C24.2134 20.96 24.587 20.96 24.9021 21.1216L27.9709 22.6953L27.4145 19.2771C27.3566 18.9217 27.4764 18.5604 27.7352 18.3099L30.1675 15.9561L26.7516 15.4903C26.3875 15.4407 26.0722 15.2125 25.9113 14.8822L24.4002 11.7804ZM26.0026 10.0464C25.7071 9.36199 25.0581 9.02539 24.4377 9.02539C23.8174 9.02539 23.2076 9.35005 22.8569 9.93445C22.8405 9.96183 22.8253 9.98992 22.8113 10.0186L21.1679 13.3919L17.5055 13.9029C16.7014 13.9467 16.2259 14.5447 16.0566 15.0525C15.8855 15.5659 15.9215 16.2288 16.3202 16.7604C16.355 16.8068 16.3935 16.8505 16.4352 16.8909L19.1221 19.4911L18.517 23.2079C18.2491 24.6354 19.6846 25.6114 20.9087 25.1217C20.9405 25.109 20.9717 25.0948 21.0021 25.0792L24.4002 23.3366L27.7982 25.0792L27.7982 25.0792L27.8082 25.0843C28.4773 25.4188 29.1693 25.2071 29.5882 24.8999C30.0234 24.5807 30.4247 23.9692 30.2834 23.2087L29.6783 19.4911L32.3651 16.8909L32.378 16.8782C32.88 16.3762 33.0078 15.6827 32.8475 15.106C32.692 14.5461 32.1967 13.946 31.3929 13.9029L27.6315 13.3899L26.0026 10.0464Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4644 32.8103L13.9644 28.7103L14.8361 26.6904L24.2799 30.7662C24.3289 30.7784 24.3715 30.7784 24.4205 30.7662L33.8644 26.6904L34.7361 28.7103L25.2361 32.8103C25.2073 32.8228 25.1779 32.834 25.1481 32.8439C24.6223 33.0192 24.0782 33.0192 23.5524 32.8439C23.5226 32.834 23.4932 32.8228 23.4644 32.8103Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5681 39.012L13.9681 34.912L14.8322 32.8888L24.3785 36.9659C24.4281 36.9785 24.471 36.9786 24.5205 36.9662L33.9643 32.8904L34.8361 34.9104L25.3361 39.0104C25.3072 39.0228 25.2778 39.034 25.248 39.0439C24.7222 39.2192 24.1781 39.2192 23.6523 39.0439C23.6238 39.0345 23.5958 39.0238 23.5681 39.012Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    height: 30.2,
    fill: "white",
    transform: "translate(14 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMilitaryLight);
export default __webpack_public_path__ + "static/media/icon_military_light.725664ac.svg";
export { ForwardRef as ReactComponent };